import { render, staticRenderFns } from "./pin-create.vue?vue&type=template&id=ff9be0e6&"
import script from "./pin-create.vue?vue&type=script&lang=js&"
export * from "./pin-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports